/**
 * Reader district preference helpers (localStorage + geo utilities).
 * Used by the smart district box at the end of general blog posts.
 */
const KEY = "adf_preferred_district";

export const rememberDistrict = (slug) => {
  try {
    if (slug) localStorage.setItem(KEY, slug);
  } catch {
    /* storage unavailable (private mode) */
  }
};

export const getPreferredDistrict = () => {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
};

export const clearPreferredDistrict = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};

const toRad = (v) => (v * Math.PI) / 180;

/** Great-circle distance in km. */
export const distanceKm = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
};

/** Nearest district (with distance) to a coordinate. */
export const nearestDistrict = (districts, lat, lng) => {
  let best = null;
  for (const d of districts || []) {
    if (typeof d.lat !== "number" || typeof d.lng !== "number") continue;
    const km = distanceKm(lat, lng, d.lat, d.lng);
    if (!best || km < best.km) best = { district: d, km };
  }
  return best;
};

/** Districts whose name appears in the article text, in order of first mention. */
export const mentionedDistricts = (districts, text) => {
  if (!text) return [];
  const lower = text.toLocaleLowerCase("tr-TR");
  const hits = [];
  for (const d of districts || []) {
    const idx = lower.indexOf(d.name.toLocaleLowerCase("tr-TR"));
    if (idx !== -1) hits.push({ district: d, idx });
  }
  return hits.sort((a, b) => a.idx - b.idx).map((h) => h.district);
};
